<template>
  <div>
    <div class="air__utils__heading">
      <h3>Privacidad</h3>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <a-tabs defaultActiveKey="1" @change="callback">
          <a-tab-pane tab="Politicas de Privacidad" key="1">
            <!-- <a-textarea placeholder="Politicas de Privacidad" :value="privacyPolitics"  :rows="6"/> -->
            <div v-html="privacyPolitics"></div>
          </a-tab-pane>
          <a-tab-pane tab="Terminos y condiciones" key="2" forceRender>
              <div v-html="habeasData"></div>
          </a-tab-pane>
          <a-tab-pane tab="Politica de tratamiento de datos personales" key="3">
              <div v-html="termsAndConditions"></div>
          </a-tab-pane>
          <a-button slot="tabBarExtraContent">Editar</a-button>
        </a-tabs>
      </div>
    </div>
  </div>
</template>

<script>

import { RepositoryFactory } from './../../repository/RepositoryFactory'

const PrivacyRepository = RepositoryFactory.get('privacy')

export default {
  components: {
    // TableSliders,
  },
  data () {
    return {
      privacyPolitics: '',
      habeasData: '',
      termsAndConditions: '',
    }
  },
  created() {
    this.fetch()
  },
  methods: {
    async fetch () {
      this.$nprogress.start()
      try {
        const { data } = await PrivacyRepository.get()
        console.log(data)
        this.privacyPolitics = data.privacyPolitics
        this.habeasData = data.habeasData
        this.termsAndConditions = data.termsAndConditions
      } catch (error) {
        console.log(error)
        this.$notification['warning']({
          message: error.code,
          description: error.message,
        })
      }
      this.$nprogress.done()
    },
  },
}
</script>
